export default {"src":"/_next/static/media/sad-face.0afffbe3.svg","height":30,"width":30};